var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2381"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2381"] = parcelRequire;
}
parcelRequire.register("dLV33", function(module, exports) {
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */ (function(global, factory) {
    // universal module definition
    if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    function EvEmitter() {}
    let proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // set events hash
        let events = this._events = this._events || {};
        // set listeners array
        let listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (!listeners.includes(listener)) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return this;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        let onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        let onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        let index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        let listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return this;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        let onceListeners = this._onceEvents && this._onceEvents[eventName];
        for (let listener of listeners){
            let isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
        return this;
    };
    return EvEmitter;
});

});


var $5Fmyj = parcelRequire("5Fmyj");

var $h9NR5 = parcelRequire("h9NR5");
var $dba82c9dc9c63309$exports = {};

/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */ (function(window1, factory) {
    // universal module definition
    if (0, $dba82c9dc9c63309$exports) // CommonJS
    $dba82c9dc9c63309$exports = factory(window1, (parcelRequire("dLV33")));
    else // browser global
    window1.imagesLoaded = factory(window1, window1.EvEmitter);
})(typeof window !== "undefined" ? window : $dba82c9dc9c63309$exports, function factory(window1, EvEmitter) {
    let $ = window1.jQuery;
    let console = window1.console;
    // -------------------------- helpers -------------------------- //
    // turn element or nodeList into an array
    function makeArray(obj) {
        // use object if already an array
        if (Array.isArray(obj)) return obj;
        let isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        // convert nodeList to array
        if (isArrayLike) return [
            ...obj
        ];
        // array of single index
        return [
            obj
        ];
    }
    // -------------------------- imagesLoaded -------------------------- //
    /**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */ function ImagesLoaded(elem, options, onAlways) {
        // coerce ImagesLoaded() without new, to be new ImagesLoaded()
        if (!(this instanceof ImagesLoaded)) return new ImagesLoaded(elem, options, onAlways);
        // use elem as selector string
        let queryElem = elem;
        if (typeof elem == "string") queryElem = document.querySelectorAll(elem);
        // bail if bad element
        if (!queryElem) {
            console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
            return;
        }
        this.elements = makeArray(queryElem);
        this.options = {};
        // shift arguments if no options set
        if (typeof options == "function") onAlways = options;
        else Object.assign(this.options, options);
        if (onAlways) this.on("always", onAlways);
        this.getImages();
        // add jQuery Deferred object
        if ($) this.jqDeferred = new $.Deferred();
        // HACK check async to allow time to bind listeners
        setTimeout(this.check.bind(this));
    }
    ImagesLoaded.prototype = Object.create(EvEmitter.prototype);
    ImagesLoaded.prototype.getImages = function() {
        this.images = [];
        // filter & find items if we have an item selector
        this.elements.forEach(this.addElementImages, this);
    };
    const elementNodeTypes = [
        1,
        9,
        11
    ];
    /**
 * @param {Node} elem
 */ ImagesLoaded.prototype.addElementImages = function(elem) {
        // filter siblings
        if (elem.nodeName === "IMG") this.addImage(elem);
        // get background image on element
        if (this.options.background === true) this.addElementBackgroundImages(elem);
        // find children
        // no non-element nodes, #143
        let { nodeType: nodeType } = elem;
        if (!nodeType || !elementNodeTypes.includes(nodeType)) return;
        let childImgs = elem.querySelectorAll("img");
        // concat childElems to filterFound array
        for (let img of childImgs)this.addImage(img);
        // get child background images
        if (typeof this.options.background == "string") {
            let children = elem.querySelectorAll(this.options.background);
            for (let child of children)this.addElementBackgroundImages(child);
        }
    };
    const reURL = /url\((['"])?(.*?)\1\)/gi;
    ImagesLoaded.prototype.addElementBackgroundImages = function(elem) {
        let style = getComputedStyle(elem);
        // Firefox returns null if in a hidden iframe https://bugzil.la/548397
        if (!style) return;
        // get url inside url("...")
        let matches = reURL.exec(style.backgroundImage);
        while(matches !== null){
            let url = matches && matches[2];
            if (url) this.addBackground(url, elem);
            matches = reURL.exec(style.backgroundImage);
        }
    };
    /**
 * @param {Image} img
 */ ImagesLoaded.prototype.addImage = function(img) {
        let loadingImage = new LoadingImage(img);
        this.images.push(loadingImage);
    };
    ImagesLoaded.prototype.addBackground = function(url, elem) {
        let background = new Background(url, elem);
        this.images.push(background);
    };
    ImagesLoaded.prototype.check = function() {
        this.progressedCount = 0;
        this.hasAnyBroken = false;
        // complete if no images
        if (!this.images.length) {
            this.complete();
            return;
        }
        /* eslint-disable-next-line func-style */ let onProgress = (image, elem, message)=>{
            // HACK - Chrome triggers event before object properties have changed. #83
            setTimeout(()=>{
                this.progress(image, elem, message);
            });
        };
        this.images.forEach(function(loadingImage) {
            loadingImage.once("progress", onProgress);
            loadingImage.check();
        });
    };
    ImagesLoaded.prototype.progress = function(image, elem, message) {
        this.progressedCount++;
        this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
        // progress event
        this.emitEvent("progress", [
            this,
            image,
            elem
        ]);
        if (this.jqDeferred && this.jqDeferred.notify) this.jqDeferred.notify(this, image);
        // check if completed
        if (this.progressedCount === this.images.length) this.complete();
        if (this.options.debug && console) console.log(`progress: ${message}`, image, elem);
    };
    ImagesLoaded.prototype.complete = function() {
        let eventName = this.hasAnyBroken ? "fail" : "done";
        this.isComplete = true;
        this.emitEvent(eventName, [
            this
        ]);
        this.emitEvent("always", [
            this
        ]);
        if (this.jqDeferred) {
            let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[jqMethod](this);
        }
    };
    // --------------------------  -------------------------- //
    function LoadingImage(img) {
        this.img = img;
    }
    LoadingImage.prototype = Object.create(EvEmitter.prototype);
    LoadingImage.prototype.check = function() {
        // If complete is true and browser supports natural sizes,
        // try to check for image status manually.
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            // report based on naturalWidth
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            return;
        }
        // If none of the checks above matched, simulate loading on detached element.
        this.proxyImage = new Image();
        // add crossOrigin attribute. #204
        if (this.img.crossOrigin) this.proxyImage.crossOrigin = this.img.crossOrigin;
        this.proxyImage.addEventListener("load", this);
        this.proxyImage.addEventListener("error", this);
        // bind to image as well for Firefox. #191
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.proxyImage.src = this.img.currentSrc || this.img.src;
    };
    LoadingImage.prototype.getIsImageComplete = function() {
        // check for non-zero, non-undefined naturalWidth
        // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
        return this.img.complete && this.img.naturalWidth;
    };
    LoadingImage.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        let { parentNode: parentNode } = this.img;
        // emit progress with parent <picture> or self <img>
        let elem = parentNode.nodeName === "PICTURE" ? parentNode : this.img;
        this.emitEvent("progress", [
            this,
            elem,
            message
        ]);
    };
    // ----- events ----- //
    // trigger specified handler for event type
    LoadingImage.prototype.handleEvent = function(event) {
        let method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    LoadingImage.prototype.onload = function() {
        this.confirm(true, "onload");
        this.unbindEvents();
    };
    LoadingImage.prototype.onerror = function() {
        this.confirm(false, "onerror");
        this.unbindEvents();
    };
    LoadingImage.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this);
        this.proxyImage.removeEventListener("error", this);
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    // -------------------------- Background -------------------------- //
    function Background(url, element) {
        this.url = url;
        this.element = element;
        this.img = new Image();
    }
    // inherit LoadingImage prototype
    Background.prototype = Object.create(LoadingImage.prototype);
    Background.prototype.check = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        this.img.src = this.url;
        // check if image is already complete
        let isComplete = this.getIsImageComplete();
        if (isComplete) {
            this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
            this.unbindEvents();
        }
    };
    Background.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
    };
    Background.prototype.confirm = function(isLoaded, message) {
        this.isLoaded = isLoaded;
        this.emitEvent("progress", [
            this,
            this.element,
            message
        ]);
    };
    // -------------------------- jQuery -------------------------- //
    ImagesLoaded.makeJQueryPlugin = function(jQuery) {
        jQuery = jQuery || window1.jQuery;
        if (!jQuery) return;
        // set local variable
        $ = jQuery;
        // $().imagesLoaded()
        $.fn.imagesLoaded = function(options, onAlways) {
            let instance = new ImagesLoaded(this, options, onAlways);
            return instance.jqDeferred.promise($(this));
        };
    };
    // try making plugin
    ImagesLoaded.makeJQueryPlugin();
    // --------------------------  -------------------------- //
    return ImagesLoaded;
});


// Map number x from range [a, b] to [c, d]
const $fe8af8a42c4a74bc$export$871de8747c9eaa88 = (x, a, b, c, d)=>(x - a) * (d - c) / (b - a) + c;
// Linear interpolation
const $fe8af8a42c4a74bc$export$3a89f8d6f6bf6c9f = (a, b, n)=>(1 - n) * a + n * b;
const $fe8af8a42c4a74bc$export$48a16acaeda4ce0e = ()=>{
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
};
const $fe8af8a42c4a74bc$export$eab19c48dcb6310d = (min, max)=>Math.floor(Math.random() * (max - min + 1) + min);
// Gets the mouse position
const $fe8af8a42c4a74bc$export$8b59d3c9ad87edcd = (e)=>{
    return {
        x: e.clientX,
        y: e.clientY
    };
};
// Preload images
const $fe8af8a42c4a74bc$export$6b05b21262ec0515 = (selector)=>{
    return new Promise((resolve, reject)=>{
        $dba82c9dc9c63309$exports(document.querySelectorAll(selector), resolve);
    });
};


// Calculate the viewport size
let $aec4f61cc4074d47$var$winsize = (0, $fe8af8a42c4a74bc$export$48a16acaeda4ce0e)();
window.addEventListener("resize", ()=>$aec4f61cc4074d47$var$winsize = (0, $fe8af8a42c4a74bc$export$48a16acaeda4ce0e)());
let $aec4f61cc4074d47$var$mousepos = {
    x: $aec4f61cc4074d47$var$winsize.width / 2,
    y: $aec4f61cc4074d47$var$winsize.height / 2
};
window.addEventListener("mousemove", (ev)=>$aec4f61cc4074d47$var$mousepos = (0, $fe8af8a42c4a74bc$export$8b59d3c9ad87edcd)(ev));
class $aec4f61cc4074d47$var$GridItem {
    constructor(el){
        this.DOM = {
            el: el
        };
        this.DOM.inner = this.DOM.el.querySelector(".grid__item-img");
        this.move();
    }
    move() {
        this.invertMovement = !(0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(0, 3);
        let translationVals = {
            tx: 0,
            ty: 0
        };
        const xstart = this.invertMovement ? (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(20, 70) : (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(40, 80);
        const ystart = this.invertMovement ? (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(10, 60) : (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(40, 80);
        // also moving inner image (max 50px on each side - to change this limit change it also in the CSS)
        let translationInnerVals = {
            tx: 0,
            ty: 0
        };
        const xstartInner = this.invertMovement ? (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(0, 25) : (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(0, 50);
        const ystartInner = this.invertMovement ? (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(0, 25) : (0, $fe8af8a42c4a74bc$export$eab19c48dcb6310d)(0, 50);
        const render = ()=>{
            translationVals.tx = (0, $fe8af8a42c4a74bc$export$3a89f8d6f6bf6c9f)(translationVals.tx, (0, $fe8af8a42c4a74bc$export$871de8747c9eaa88)($aec4f61cc4074d47$var$mousepos.x, 0, $aec4f61cc4074d47$var$winsize.width, this.invertMovement ? xstart : -xstart, this.invertMovement ? -xstart : xstart), 0.07);
            translationVals.ty = (0, $fe8af8a42c4a74bc$export$3a89f8d6f6bf6c9f)(translationVals.ty, (0, $fe8af8a42c4a74bc$export$871de8747c9eaa88)($aec4f61cc4074d47$var$mousepos.y, 0, $aec4f61cc4074d47$var$winsize.height, this.invertMovement ? ystart : -ystart, this.invertMovement ? -ystart : ystart), 0.07);
            (0, $h9NR5.gsap).set(this.DOM.el, {
                x: translationVals.tx,
                y: translationVals.ty
            });
            translationInnerVals.tx = (0, $fe8af8a42c4a74bc$export$3a89f8d6f6bf6c9f)(translationInnerVals.tx, (0, $fe8af8a42c4a74bc$export$871de8747c9eaa88)($aec4f61cc4074d47$var$mousepos.x, 0, $aec4f61cc4074d47$var$winsize.width, this.invertMovement ? -xstartInner : xstartInner, this.invertMovement ? xstartInner : -xstartInner), 0.07);
            translationInnerVals.ty = (0, $fe8af8a42c4a74bc$export$3a89f8d6f6bf6c9f)(translationInnerVals.ty, (0, $fe8af8a42c4a74bc$export$871de8747c9eaa88)($aec4f61cc4074d47$var$mousepos.y, 0, $aec4f61cc4074d47$var$winsize.height, this.invertMovement ? -ystartInner : ystartInner, this.invertMovement ? ystartInner : -ystartInner), 0.07);
            (0, $h9NR5.gsap).set(this.DOM.inner, {
                x: translationInnerVals.tx,
                y: translationInnerVals.ty
            });
            requestAnimationFrame(render);
        };
        requestAnimationFrame(render);
    }
}
class $aec4f61cc4074d47$export$2e2bcd8739ae039 {
    constructor(el){
        this.DOM = {
            el: el
        };
        this.gridItems = [];
        this.items = [
            ...this.DOM.el.querySelectorAll(".grid__item")
        ];
        this.items.forEach((item)=>this.gridItems.push(new $aec4f61cc4074d47$var$GridItem(item)));
        this.showItems();
    }
    // Initial animation to scale up and fade in the items
    showItems() {
        (0, $h9NR5.gsap).timeline().set(this.items, {
            scale: (pos)=>this.gridItems[pos].invertMovement ? 0.2 : 0.6,
            opacity: 0
        }, 0).to(this.items, {
            duration: 2,
            ease: "expo.out",
            scale: (pos)=>this.gridItems[pos].invertMovement ? 0.5 : 1,
            stagger: {
                amount: 0.6,
                grid: "auto",
                from: "center"
            }
        }, 0).to(this.items, {
            duration: 2,
            ease: "power1.out",
            opacity: (pos)=>this.gridItems[pos].invertMovement ? 0.3 : 0.9,
            stagger: {
                amount: 0.6,
                grid: "auto",
                from: "center"
            }
        }, 0);
    }
}




var $h9NR5 = parcelRequire("h9NR5");
/*!
 * CSSRulePlugin 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $dd39c48a5076c1b8$var$gsap, $dd39c48a5076c1b8$var$_coreInitted, $dd39c48a5076c1b8$var$_win, $dd39c48a5076c1b8$var$_doc, $dd39c48a5076c1b8$var$CSSPlugin, $dd39c48a5076c1b8$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $dd39c48a5076c1b8$var$_getGSAP = function _getGSAP() {
    return $dd39c48a5076c1b8$var$gsap || $dd39c48a5076c1b8$var$_windowExists() && ($dd39c48a5076c1b8$var$gsap = window.gsap) && $dd39c48a5076c1b8$var$gsap.registerPlugin && $dd39c48a5076c1b8$var$gsap;
}, $dd39c48a5076c1b8$var$_checkRegister = function _checkRegister() {
    if (!$dd39c48a5076c1b8$var$_coreInitted) {
        $dd39c48a5076c1b8$var$_initCore();
        if (!$dd39c48a5076c1b8$var$CSSPlugin) console.warn("Please gsap.registerPlugin(CSSPlugin, CSSRulePlugin)");
    }
    return $dd39c48a5076c1b8$var$_coreInitted;
}, $dd39c48a5076c1b8$var$_initCore = function _initCore(core) {
    $dd39c48a5076c1b8$var$gsap = core || $dd39c48a5076c1b8$var$_getGSAP();
    if ($dd39c48a5076c1b8$var$_windowExists()) {
        $dd39c48a5076c1b8$var$_win = window;
        $dd39c48a5076c1b8$var$_doc = document;
    }
    if ($dd39c48a5076c1b8$var$gsap) {
        $dd39c48a5076c1b8$var$CSSPlugin = $dd39c48a5076c1b8$var$gsap.plugins.css;
        if ($dd39c48a5076c1b8$var$CSSPlugin) $dd39c48a5076c1b8$var$_coreInitted = 1;
    }
};
var $dd39c48a5076c1b8$export$c4840e59fc63112f = {
    version: "3.12.2",
    name: "cssRule",
    init: function init(target, value, tween, index, targets) {
        if (!$dd39c48a5076c1b8$var$_checkRegister() || typeof target.cssText === "undefined") return false;
        var div = target._gsProxy = target._gsProxy || $dd39c48a5076c1b8$var$_doc.createElement("div");
        this.ss = target;
        this.style = div.style;
        div.style.cssText = target.cssText;
        $dd39c48a5076c1b8$var$CSSPlugin.prototype.init.call(this, div, value, tween, index, targets); //we just offload all the work to the regular CSSPlugin and then copy the cssText back over to the rule in the render() method. This allows us to have all of the updates to CSSPlugin automatically flow through to CSSRulePlugin instead of having to maintain both
    },
    render: function render(ratio, data) {
        var pt = data._pt, style = data.style, ss = data.ss, i;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        i = style.length;
        while(--i > -1)ss[style[i]] = style[style[i]];
    },
    getRule: function getRule(selector) {
        $dd39c48a5076c1b8$var$_checkRegister();
        var ruleProp = $dd39c48a5076c1b8$var$_doc.all ? "rules" : "cssRules", styleSheets = $dd39c48a5076c1b8$var$_doc.styleSheets, i = styleSheets.length, pseudo = selector.charAt(0) === ":", j, curSS, cs, a;
        selector = (pseudo ? "" : ",") + selector.split("::").join(":").toLowerCase() + ","; //note: old versions of IE report tag name selectors as upper case, so we just change everything to lowercase.
        if (pseudo) a = [];
        while(i--){
            //Firefox may throw insecure operation errors when css is loaded from other domains, so try/catch.
            try {
                curSS = styleSheets[i][ruleProp];
                if (!curSS) continue;
                j = curSS.length;
            } catch (e) {
                console.warn(e);
                continue;
            }
            while(--j > -1){
                cs = curSS[j];
                if (cs.selectorText && ("," + cs.selectorText.split("::").join(":").toLowerCase() + ",").indexOf(selector) !== -1) {
                    //note: IE adds an extra ":" to pseudo selectors, so .myClass:after becomes .myClass::after, so we need to strip the extra one out.
                    if (pseudo) a.push(cs.style);
                    else return cs.style;
                }
            }
        }
        return a;
    },
    register: $dd39c48a5076c1b8$var$_initCore
};
$dd39c48a5076c1b8$var$_getGSAP() && $dd39c48a5076c1b8$var$gsap.registerPlugin($dd39c48a5076c1b8$export$c4840e59fc63112f);


/*!
 * DrawSVGPlugin 3.12.2
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $1ad04a3649455f90$var$gsap, $1ad04a3649455f90$var$_toArray, $1ad04a3649455f90$var$_doc, $1ad04a3649455f90$var$_win, $1ad04a3649455f90$var$_isEdge, $1ad04a3649455f90$var$_coreInitted, $1ad04a3649455f90$var$_warned, $1ad04a3649455f90$var$_getStyleSaver, $1ad04a3649455f90$var$_reverting, $1ad04a3649455f90$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $1ad04a3649455f90$var$_getGSAP = function _getGSAP() {
    return $1ad04a3649455f90$var$gsap || $1ad04a3649455f90$var$_windowExists() && ($1ad04a3649455f90$var$gsap = window.gsap) && $1ad04a3649455f90$var$gsap.registerPlugin && $1ad04a3649455f90$var$gsap;
}, $1ad04a3649455f90$var$_numExp = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$1ad04a3649455f90$var$_types = {
    rect: [
        "width",
        "height"
    ],
    circle: [
        "r",
        "r"
    ],
    ellipse: [
        "rx",
        "ry"
    ],
    line: [
        "x2",
        "y2"
    ]
}, $1ad04a3649455f90$var$_round = function _round(value) {
    return Math.round(value * 10000) / 10000;
}, $1ad04a3649455f90$var$_parseNum = function _parseNum(value) {
    return parseFloat(value) || 0;
}, $1ad04a3649455f90$var$_parseSingleVal = function _parseSingleVal(value, length) {
    var num = $1ad04a3649455f90$var$_parseNum(value);
    return ~value.indexOf("%") ? num / 100 * length : num;
}, $1ad04a3649455f90$var$_getAttributeAsNumber = function _getAttributeAsNumber(target, attr) {
    return $1ad04a3649455f90$var$_parseNum(target.getAttribute(attr));
}, $1ad04a3649455f90$var$_sqrt = Math.sqrt, $1ad04a3649455f90$var$_getDistance = function _getDistance(x1, y1, x2, y2, scaleX, scaleY) {
    return $1ad04a3649455f90$var$_sqrt(Math.pow(($1ad04a3649455f90$var$_parseNum(x2) - $1ad04a3649455f90$var$_parseNum(x1)) * scaleX, 2) + Math.pow(($1ad04a3649455f90$var$_parseNum(y2) - $1ad04a3649455f90$var$_parseNum(y1)) * scaleY, 2));
}, $1ad04a3649455f90$var$_warn = function _warn(message) {
    return console.warn(message);
}, $1ad04a3649455f90$var$_hasNonScalingStroke = function _hasNonScalingStroke(target) {
    return target.getAttribute("vector-effect") === "non-scaling-stroke";
}, $1ad04a3649455f90$var$_bonusValidated = 1, //<name>DrawSVGPlugin</name>
//accepts values like "100%" or "20% 80%" or "20 50" and parses it into an absolute start and end position on the line/stroke based on its length. Returns an an array with the start and end values, like [0, 243]
$1ad04a3649455f90$var$_parse = function _parse(value, length, defaultStart) {
    var i = value.indexOf(" "), s, e;
    if (i < 0) {
        s = defaultStart !== undefined ? defaultStart + "" : value;
        e = value;
    } else {
        s = value.substr(0, i);
        e = value.substr(i + 1);
    }
    s = $1ad04a3649455f90$var$_parseSingleVal(s, length);
    e = $1ad04a3649455f90$var$_parseSingleVal(e, length);
    return s > e ? [
        e,
        s
    ] : [
        s,
        e
    ];
}, $1ad04a3649455f90$var$_getLength = function _getLength(target) {
    target = $1ad04a3649455f90$var$_toArray(target)[0];
    if (!target) return 0;
    var type = target.tagName.toLowerCase(), style = target.style, scaleX = 1, scaleY = 1, length, bbox, points, prevPoint, i, rx, ry;
    if ($1ad04a3649455f90$var$_hasNonScalingStroke(target)) {
        //non-scaling-stroke basically scales the shape and then strokes it at the screen-level (after transforms), thus we need to adjust the length accordingly.
        scaleY = target.getScreenCTM();
        scaleX = $1ad04a3649455f90$var$_sqrt(scaleY.a * scaleY.a + scaleY.b * scaleY.b);
        scaleY = $1ad04a3649455f90$var$_sqrt(scaleY.d * scaleY.d + scaleY.c * scaleY.c);
    }
    try {
        //IE bug: calling <path>.getTotalLength() locks the repaint area of the stroke to whatever its current dimensions are on that frame/tick. To work around that, we must call getBBox() to force IE to recalculate things.
        bbox = target.getBBox(); //solely for fixing bug in IE - we don't actually use the bbox.
    } catch (e) {
        //firefox has a bug that throws an error if the element isn't visible.
        $1ad04a3649455f90$var$_warn("Some browsers won't measure invisible elements (like display:none or masks inside defs).");
    }
    var _ref = bbox || {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    }, x = _ref.x, y = _ref.y, width = _ref.width, height = _ref.height;
    if ((!bbox || !width && !height) && $1ad04a3649455f90$var$_types[type]) {
        //if the element isn't visible, try to discern width/height using its attributes.
        width = $1ad04a3649455f90$var$_getAttributeAsNumber(target, $1ad04a3649455f90$var$_types[type][0]);
        height = $1ad04a3649455f90$var$_getAttributeAsNumber(target, $1ad04a3649455f90$var$_types[type][1]);
        if (type !== "rect" && type !== "line") {
            //double the radius for circles and ellipses
            width *= 2;
            height *= 2;
        }
        if (type === "line") {
            x = $1ad04a3649455f90$var$_getAttributeAsNumber(target, "x1");
            y = $1ad04a3649455f90$var$_getAttributeAsNumber(target, "y1");
            width = Math.abs(width - x);
            height = Math.abs(height - y);
        }
    }
    if (type === "path") {
        prevPoint = style.strokeDasharray;
        style.strokeDasharray = "none";
        length = target.getTotalLength() || 0;
        $1ad04a3649455f90$var$_round(scaleX) !== $1ad04a3649455f90$var$_round(scaleY) && !$1ad04a3649455f90$var$_warned && ($1ad04a3649455f90$var$_warned = 1) && $1ad04a3649455f90$var$_warn("Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled.");
        length *= (scaleX + scaleY) / 2;
        style.strokeDasharray = prevPoint;
    } else if (type === "rect") length = width * 2 * scaleX + height * 2 * scaleY;
    else if (type === "line") length = $1ad04a3649455f90$var$_getDistance(x, y, x + width, y + height, scaleX, scaleY);
    else if (type === "polyline" || type === "polygon") {
        points = target.getAttribute("points").match($1ad04a3649455f90$var$_numExp) || [];
        type === "polygon" && points.push(points[0], points[1]);
        length = 0;
        for(i = 2; i < points.length; i += 2)length += $1ad04a3649455f90$var$_getDistance(points[i - 2], points[i - 1], points[i], points[i + 1], scaleX, scaleY) || 0;
    } else if (type === "circle" || type === "ellipse") {
        rx = width / 2 * scaleX;
        ry = height / 2 * scaleY;
        length = Math.PI * (3 * (rx + ry) - $1ad04a3649455f90$var$_sqrt((3 * rx + ry) * (rx + 3 * ry)));
    }
    return length || 0;
}, $1ad04a3649455f90$var$_getPosition = function _getPosition(target, length) {
    target = $1ad04a3649455f90$var$_toArray(target)[0];
    if (!target) return [
        0,
        0
    ];
    length || (length = $1ad04a3649455f90$var$_getLength(target) + 1);
    var cs = $1ad04a3649455f90$var$_win.getComputedStyle(target), dash = cs.strokeDasharray || "", offset = $1ad04a3649455f90$var$_parseNum(cs.strokeDashoffset), i = dash.indexOf(",");
    i < 0 && (i = dash.indexOf(" "));
    dash = i < 0 ? length : $1ad04a3649455f90$var$_parseNum(dash.substr(0, i));
    dash > length && (dash = length);
    return [
        -offset || 0,
        dash - offset || 0
    ];
}, $1ad04a3649455f90$var$_initCore = function _initCore() {
    if ($1ad04a3649455f90$var$_windowExists()) {
        $1ad04a3649455f90$var$_doc = document;
        $1ad04a3649455f90$var$_win = window;
        $1ad04a3649455f90$var$_coreInitted = $1ad04a3649455f90$var$gsap = $1ad04a3649455f90$var$_getGSAP();
        $1ad04a3649455f90$var$_toArray = $1ad04a3649455f90$var$gsap.utils.toArray;
        $1ad04a3649455f90$var$_getStyleSaver = $1ad04a3649455f90$var$gsap.core.getStyleSaver;
        $1ad04a3649455f90$var$_reverting = $1ad04a3649455f90$var$gsap.core.reverting || function() {};
        $1ad04a3649455f90$var$_isEdge = (($1ad04a3649455f90$var$_win.navigator || {}).userAgent || "").indexOf("Edge") !== -1; //Microsoft Edge has a bug that causes it not to redraw the path correctly if the stroke-linecap is anything other than "butt" (like "round") and it doesn't match the stroke-linejoin. A way to trigger it is to change the stroke-miterlimit, so we'll only do that if/when we have to (to maximize performance)
    }
};
var $1ad04a3649455f90$export$4129f9ba90e1264a = {
    version: "3.12.2",
    name: "drawSVG",
    register: function register(core) {
        $1ad04a3649455f90$var$gsap = core;
        $1ad04a3649455f90$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        if (!target.getBBox) return false;
        $1ad04a3649455f90$var$_coreInitted || $1ad04a3649455f90$var$_initCore();
        var length = $1ad04a3649455f90$var$_getLength(target), start, end, cs;
        this.styles = $1ad04a3649455f90$var$_getStyleSaver && $1ad04a3649455f90$var$_getStyleSaver(target, "strokeDashoffset,strokeDasharray,strokeMiterlimit");
        this.tween = tween;
        this._style = target.style;
        this._target = target;
        if (value + "" === "true") value = "0 100%";
        else if (!value) value = "0 0";
        else if ((value + "").indexOf(" ") === -1) value = "0 " + value;
        start = $1ad04a3649455f90$var$_getPosition(target, length);
        end = $1ad04a3649455f90$var$_parse(value, length, start[0]);
        this._length = $1ad04a3649455f90$var$_round(length);
        this._dash = $1ad04a3649455f90$var$_round(start[1] - start[0]); //some browsers render artifacts if dash is 0, so we use a very small number in that case.
        this._offset = $1ad04a3649455f90$var$_round(-start[0]);
        this._dashPT = this.add(this, "_dash", this._dash, $1ad04a3649455f90$var$_round(end[1] - end[0]), 0, 0, 0, 0, 0, 1);
        this._offsetPT = this.add(this, "_offset", this._offset, $1ad04a3649455f90$var$_round(-end[0]), 0, 0, 0, 0, 0, 1);
        if ($1ad04a3649455f90$var$_isEdge) {
            //to work around a bug in Microsoft Edge, animate the stroke-miterlimit by 0.0001 just to trigger the repaint (unnecessary if it's "round" and stroke-linejoin is also "round"). Imperceptible, relatively high-performance, and effective. Another option was to set the "d" <path> attribute to its current value on every tick, but that seems like it'd be much less performant.
            cs = $1ad04a3649455f90$var$_win.getComputedStyle(target);
            if (cs.strokeLinecap !== cs.strokeLinejoin) {
                end = $1ad04a3649455f90$var$_parseNum(cs.strokeMiterlimit);
                this.add(target.style, "strokeMiterlimit", end, end + 0.01);
            }
        }
        this._live = $1ad04a3649455f90$var$_hasNonScalingStroke(target) || ~(value + "").indexOf("live");
        this._nowrap = ~(value + "").indexOf("nowrap");
        this._props.push("drawSVG");
        return $1ad04a3649455f90$var$_bonusValidated;
    },
    render: function render(ratio, data) {
        if (data.tween._time || !$1ad04a3649455f90$var$_reverting()) {
            var pt = data._pt, style = data._style, length, lengthRatio, dash, offset;
            if (pt) {
                //when the element has vector-effect="non-scaling-stroke" and the SVG is resized (like on a window resize), it actually changes the length of the stroke! So we must sense that and make the proper adjustments.
                if (data._live) {
                    length = $1ad04a3649455f90$var$_getLength(data._target);
                    if (length !== data._length) {
                        lengthRatio = length / data._length;
                        data._length = length;
                        if (data._offsetPT) {
                            data._offsetPT.s *= lengthRatio;
                            data._offsetPT.c *= lengthRatio;
                        }
                        if (data._dashPT) {
                            data._dashPT.s *= lengthRatio;
                            data._dashPT.c *= lengthRatio;
                        } else data._dash *= lengthRatio;
                    }
                }
                while(pt){
                    pt.r(ratio, pt.d);
                    pt = pt._next;
                }
                dash = data._dash || ratio && ratio !== 1 && 0.0001 || 0; // only let it be zero if it's at the start or end of the tween.
                length = data._length - dash + 0.1;
                offset = data._offset;
                dash && offset && dash + Math.abs(offset % data._length) > data._length - 0.2 && (offset += offset < 0 ? 0.1 : -0.1) && (length += 0.1);
                style.strokeDashoffset = dash ? offset : offset + 0.001;
                style.strokeDasharray = length < 0.2 ? "none" : dash ? dash + "px," + (data._nowrap ? 999999 : length) + "px" : "0px, 999999px";
            }
        } else data.styles.revert();
    },
    getLength: $1ad04a3649455f90$var$_getLength,
    getPosition: $1ad04a3649455f90$var$_getPosition
};
$1ad04a3649455f90$var$_getGSAP() && $1ad04a3649455f90$var$gsap.registerPlugin($1ad04a3649455f90$export$4129f9ba90e1264a);


if (null) null.accept();
(0, $h9NR5.gsap).registerPlugin((0, $dd39c48a5076c1b8$export$c4840e59fc63112f), (0, $1ad04a3649455f90$export$4129f9ba90e1264a));
function $7a8fb0f659835779$var$init() {
    // initCursor();
    (0, $5Fmyj.initNav)();
    // Preload  images
    (0, $fe8af8a42c4a74bc$export$6b05b21262ec0515)(".grid__item-img, .bigimg").then(()=>{
        // Remove loader (loading class)
        document.body.classList.remove("loading");
        // Initialize grid
        const grid = new (0, $aec4f61cc4074d47$export$2e2bcd8739ae039)(document.querySelector(".grid"));
    });
}
window.addEventListener("load", function() {
    $7a8fb0f659835779$var$init();
});
const $7a8fb0f659835779$var$nav_rule = (0, $dd39c48a5076c1b8$export$c4840e59fc63112f).getRule(".navbar--home .nav-open li:after");
(0, $h9NR5.gsap).from($7a8fb0f659835779$var$nav_rule, {
    width: "0%",
    duration: 0.5,
    ease: "power1.out",
    delay: 1
});
const $7a8fb0f659835779$var$mm = (0, $h9NR5.gsap).matchMedia();
$7a8fb0f659835779$var$mm.add("(max-width: 767px)", ()=>{
    // Draw Theme Lead In
    const theme_lead_in_animation_tl = (0, $h9NR5.gsap).timeline();
    theme_lead_in_animation_tl.from(".home-title__image path", {
        duration: 4,
        drawSVG: "0%",
        ease: "slow(0.7, 0.7, false)"
    });
    theme_lead_in_animation_tl.to(".theme-lead-in__wrapper", {
        opacity: 1
    }, 0);
    theme_lead_in_animation_tl.to(".home-title__image .cls-1", {
        fill: "#191919",
        duration: 2
    });
    theme_lead_in_animation_tl.to(".home-mobile-title__link", {
        opacity: 1,
        duration: 1
    }, "<+.5");
}); // theme_lead_in_animation_tl.to(
 //   ".theme-lead-in__arrow-right",
 //   {
 //     width: "100%",
 //     duration: 0.5,
 //   },
 //   "<.5"
 // );


//# sourceMappingURL=index.e2f71da6.js.map
